// LitElement that is a paragraph block
import WarpElement from "@warp-ds/elements-core";
import { AssetFields } from "contentful/dist/types/types/asset.js";
import { css, html } from "lit";
import { PodletMetaData } from "../../../types/types-drEdition.js";
import { getPodletMetaData, setupCustomElement } from "../../lit-util.js";
import { CurrentPlatform, getCurrentPlatform } from "../utils/getCurrentPlatform.js";

const NAME = "contentful-sponsor-header";

export class ContentfulSponsorHeader extends WarpElement {
	declare entryId: string;
	declare sponsorName: string;
	declare logoImageData: AssetFields;
	declare hideAdTag: boolean;
	declare metaData: PodletMetaData;
	declare currentPlatform: CurrentPlatform;

	static properties = {
		entryId: { type: String },
		sponsorName: { type: String },
		logoImageData: { type: Object },
		hideAdTag: { type: Boolean },
	};

	constructor() {
		super();
		this.entryId = "";
		this.sponsorName = "";
		this.logoImageData = {} as AssetFields;
		this.hideAdTag = false;
		this.metaData = getPodletMetaData();

		this.currentPlatform = {} as CurrentPlatform;
		getCurrentPlatform(this, (currentPlatform) => {
			this.currentPlatform = currentPlatform;
			this.requestUpdate();
		});
	}

	static styles = [
		css`
			* {
				font-family: "Finntype", sans-serif;
			}

			:host {
				display: block;
			}

			.sponsor-container {
				display: flex;
				align-items: center;
				justify-content: space-between;
				gap: 1rem;
			}

			.sponsor-label {
				flex: 1;
				white-space: nowrap;
			}

			.sponsor-logo {
				display: flex;
				justify-content: flex-end;
				align-items: center;
				width: 35%;
			}

			@media (max-width: 468px) {
				.sponsor-logo {
					display: flex;
					justify-content: flex-end;
					align-items: center;
					width: 45%;
				}
			}

			.sponsor-container.dark-mode {
				color: white;
			}

			.sponsor-container.dark-mode * {
				color: white;
			}

			.sponsor-container.dark-mode img {
				background: white;
				padding: 0.2rem;
			}
			*,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0}.static{position:static}.h-64{height:6.4rem};
		`,
		...WarpElement.styles,
	] as unknown as never;

	render() {
		return html`<div
			id="sponsor-header"
			class="sponsor-container relative flex items-center justify-between p-8 h-64
				${this.metaData.darkMode ? "dark-mode" : ""}"
		>
			${this.hideAdTag
				? html`<div></div>`
				: html`<div class="sponsor-label block ml-3 font-bold text-m">
						${this.i18n.t({
							id: "common.sponsorLabel",
							message: "Annonsørinnhold",
						})}
					</div>`}
			<div class="sponsor-logo ${this.metaData.darkMode ? "s-bg" : ""} ${this.metaData.landscapeMode ? "s-bg" : ""}">
				<contentful-image
					width="auto"
					fieldId="logoImageData"
					entryId="${this.entryId}"
					.imageData="${this.logoImageData}"
					imageStyle="object-fit: contain; object-position: right; width: auto; max-height: 4.6rem"
				></contentful-image>
			</div>
		</div>`;
	}
}

setupCustomElement(NAME, ContentfulSponsorHeader);
